module.exports = __webpack_public_path__ + "static/img/slogan.da63f27.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/index1/slogan.png
// module id = Ke0n
// module chunks = 7